'use client';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TitleBanner from './TitleBanner'; // 標題 banner
import CategoryContentList from './CategoryContentList'; // 內容列表

const CategoryInner = ({
    locale,
    initList,
    category,
    type,
    initTags,
    category2,
    tagId,
    banners,
    background,
    pageCnt,
    cookies,
}) => {
    const { t } = useTranslation();
    const [tags, setTags] = useState(initTags);

    return (
        <>
            {/* 標題背景 */}
            <TitleBanner
                t={t}
                category={category}
                type={type}
                background={background}
                tags={tags}
            />

            {/* 列表＋廣告 */}
            <CategoryContentList
                locale={locale}
                banners={banners}
                pageCnt={pageCnt}
                category2={category2} // 中分類
                tagId={tagId} // 自定義 tag
                initList={initList}
                category={category}
                setTags={setTags}
                cookies={cookies}
            />
        </>
    );
};

export default CategoryInner;
